import { render } from "./CreateScenarioPage.vue?vue&type=template&id=0abd36db"
import script from "./CreateScenarioPage.vue?vue&type=script&lang=js"
export * from "./CreateScenarioPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__